/*============================================================================
  Lenora cart upsells (ported from Impulse cart-upsells.js to Dawn 16).
  Recommended products for the first cart item, rendered into [data-cart-upsells] in the
  cart drawer. Dawn replaces the drawer markup on every cart change, so the last markup is
  cached and re-mounted after each 'cart:updated' (fired by the bridge in lenora-head).
  "Add" posts to /cart/add.js with section rendering and lets Dawn's drawer re-render.
==============================================================================*/
(function () {
  'use strict';

  var MOUNT_SELECTOR = '[data-cart-upsells]';
  var LIMIT = 8;
  var lastKey = null;
  var lastProducts = [];

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function formatMoney(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var noDec = String(Math.round(cents / 100));
    function sep(v, t, d) {
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(d);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return sep(noDec, ',', '.');
        case 'amount_with_comma_separator': return sep(value, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(noDec, '.', ',');
        default: return sep(value, ',', '.');
      }
    });
  }

  function escHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function buildVariantLabel(v) {
    return (v.options || []).filter(function (o) { return o && o !== 'Default Title'; }).join(' / ') || v.title;
  }

  function buildTile(product) {
    var variants = product.variants || [];
    if (!variants.length || !variants.some(function (v) { return v.available; })) return '';
    var first = variants.find(function (v) { return v.available; }) || variants[0];
    var url = root() + 'products/' + encodeURIComponent(product.handle);
    var img = product.featured_image
      ? '<img src="' + escHtml(product.featured_image) + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="' + escHtml(product.title) + '" width="72" height="72" loading="lazy">'
      : '';
    var compare = first.compare_at_price && first.compare_at_price > first.price
      ? '<s class="cart-upsells__tile-compare">' + escHtml(formatMoney(first.compare_at_price)) + '</s> ' : '';
    var variantData = escHtml(JSON.stringify(variants.map(function (v) {
      return { id: v.id, price: v.price, compare_at_price: v.compare_at_price };
    })));
    var single = variants.length === 1 && variants[0].title === 'Default Title';
    var options = variants.map(function (v) {
      return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (v.id === first.id ? ' selected' : '') + '>' +
        escHtml(buildVariantLabel(v)) + (v.available ? '' : ' (sold out)') + '</option>';
    }).join('');

    return '<div class="cart-upsells__tile">' +
      '<a href="' + url + '" class="cart-upsells__tile-img-wrap">' + img + '</a>' +
      '<div class="cart-upsells__tile-info">' +
        '<a href="' + url + '" class="cart-upsells__tile-title">' + escHtml(product.title) + '</a>' +
        '<div class="cart-upsells__tile-price">' + compare + '<span class="cart-upsells__tile-price-current">' + escHtml(formatMoney(first.price)) + '</span></div>' +
        '<div class="cart-upsells__tile-actions">' +
          (single
            ? '<input type="hidden" class="cart-upsells__select" value="' + first.id + '">'
            : '<select class="cart-upsells__select" data-variant-data="' + variantData + '" aria-label="Select variant">' + options + '</select>') +
          '<button type="button" class="cart-upsells__tile-btn" data-upsell-add>Add</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function mount() {
    document.querySelectorAll(MOUNT_SELECTOR).forEach(function (m) {
      if (!lastProducts.length) { m.hidden = true; m.innerHTML = ''; return; }
      if (m.dataset.lnKey === lastKey) return;
      m.dataset.lnKey = lastKey;
      m.innerHTML = '<div class="cart-upsells__heading">You\'ll love these</div>' +
        '<div class="cart-upsells__track">' + lastProducts.map(buildTile).join('') + '</div>';
      m.hidden = false;
    });
  }

  function update(cart) {
    var p = cart ? Promise.resolve(cart) : fetch(root() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    p.then(function (c) {
      if (!c || !c.items || !c.items.length) { lastProducts = []; lastKey = null; mount(); return; }
      var key = c.items[0].product_id + ':' + c.items.map(function (i) { return i.product_id; }).join(',');
      if (key === lastKey) { mount(); return; }
      return fetch(root() + 'recommendations/products.json?product_id=' + c.items[0].product_id + '&limit=' + LIMIT + '&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          lastProducts = (data.products || []).filter(function (prod) {
            return !c.items.some(function (i) { return i.product_id === prod.id; });
          }).slice(0, LIMIT);
          lastKey = key;
          mount();
        });
    }).catch(function () {});
  }

  function addToCart(btn) {
    var tile = btn.closest('.cart-upsells__tile');
    var sel = tile && tile.querySelector('.cart-upsells__select');
    if (!sel || !sel.value || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.textContent = '...';
    var drawer = document.querySelector('cart-drawer');
    var body = { id: parseInt(sel.value, 10), quantity: 1 };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'error');
        if (drawer && res.sections && drawer.renderContents) drawer.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ln-cart-upsells', productVariantId: body.id, cartData: res });
        }
      })
      .catch(function () {
        btn.textContent = 'Add';
        btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.cart-upsells__select[data-variant-data]');
    if (!sel) return;
    var tile = sel.closest('.cart-upsells__tile');
    var variants = JSON.parse(sel.dataset.variantData);
    var chosen = variants.find(function (v) { return String(v.id) === sel.value; });
    if (!chosen || !tile) return;
    var priceEl = tile.querySelector('.cart-upsells__tile-price-current');
    if (priceEl) priceEl.textContent = formatMoney(chosen.price);
    var compareEl = tile.querySelector('.cart-upsells__tile-compare');
    if (compareEl) {
      var show = chosen.compare_at_price && chosen.compare_at_price > chosen.price;
      compareEl.hidden = !show;
      if (show) compareEl.textContent = formatMoney(chosen.compare_at_price);
    }
  });

  document.addEventListener('cart:updated', function (e) { update(e.detail && e.detail.cart); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { update(); });
  } else {
    update();
  }
})();
